import { createSearchClient } from './searchClient';
import GridIcon from './assets/icons/grid.svg';
import GridActiveIcon from './assets/icons/grid-active.svg';
import ListIcon from './assets/icons/list.svg';
import ListActiveIcon from './assets/icons/list-active.svg';
import MapIcon from './assets/icons/map.svg';
import MapActiveIcon from './assets/icons/map-active.svg';
import Filters from './assets/icons/filters.svg';
import FiltersActive from './assets/icons/filters-active.svg';

//import OffersIcon from './assets/icons/offer.png';

export const config = {
  // also update these in public/index.html for insights, if you update this.
  APP_ID: '06TCVB0ZTH',
  API_KEY: '6744d8dc9ba5d43a9888f20631cf5222',
  //INDEX: 'dev_gourmet_society',
  INDEX: 'prod_gourmet_society_web',
};

export const places_config = {
  APP_ID: 'plL8OWBLPX6O',
  API_KEY: 'c7f110dd8044c333a3d332e3554bf375',
};

export const client = createSearchClient({
  appId: config.APP_ID,
  apiKey: config.API_KEY,
});

export const views = [
  {
    label: 'Grid',
    icon: {
      props: ['view-active'],
      render(h) {
        if (this.viewActive) {
          return h(GridActiveIcon);
        }
        return h(GridIcon);
      },
    },
  },
  {
    label: 'Map',
    icon: {
      props: ['view-active'],
      render(h) {
        if (this.viewActive) {
          return h(MapActiveIcon);
        }
        return h(MapIcon);
      },
    },
  },
  {
    label: 'List',
    icon: {
      props: ['view-active'],
      render(h) {
        if (this.viewActive) {
          return h(ListActiveIcon);
        }
        return h(ListIcon);
      },
    },
  },
  {
    label: 'Filters',
    icon: {
      props: ['view-active'],
      render(h) {
        if (this.viewActive) {
          return h(FiltersActive);
        }
        return h(Filters);
      },
    },
  },
];

export const offerTypes = [
  {
    name: '2 for 1 meals',
    label: '2 for 1 meals',
  },
  {
    name: '50% off the Total Food Bill',
    label: '50% off food',
  },
];

export const store = {
  state: {
    //activeView: 'Grid',
    activeView: window.sessionStorage.getItem('algolia_currentView') ? window.sessionStorage.getItem('algolia_currentView') : 'Grid',
    type: undefined,
    placesDialogOpened: false,
    showDecember: false,
  },
  setShowDecember(showDecember) {
    this.state.showDecember = showDecember;
  },
  setType(type) {
    this.state.type = type;
  },
  setActiveView(activeView) {
    this.state.activeView = activeView;
  },
};

export const daysOfWeek = [
  'Saturday',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'December',
];

export const pureDaysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
